module.exports = __webpack_public_path__ + "static/media/fblog.8d16eda8.png";